import Vue from 'vue'

import DefaultLayout from './components/@layout/DefaultLayout/DefaultLayout.vue'

Vue.component('default-layout', DefaultLayout)
